import { useState } from 'react';
import { Route, NavLink, Switch } from 'react-router-dom';
import { Breadcrumb } from 'semantic-ui-react';
import AllSpecs from './Specs';
import SingleSpec from './SingleSpec';

function Specs() {
	const path     = `/specs`;
	const [ selected_spec_name, setSelectedSpecName ] = useState(``);

	function handleSetSpecName(name) {
		setSelectedSpecName(name);
	}

	return (
		<div>
			<Breadcrumb size="small">
				<Breadcrumb.Section link as={NavLink} to="/specs">Specs</Breadcrumb.Section>
				{selected_spec_name ? (
					<>
						<Breadcrumb.Divider icon='right chevron' />
						<Breadcrumb.Section active>
							Spec History
							<Breadcrumb.Divider icon='right arrow' />
							{selected_spec_name}
						</Breadcrumb.Section>
					</>
				) : null}
			</Breadcrumb>

			<Switch>
				<Route exact path={path}>
					<AllSpecs
						handleSetSpecName={handleSetSpecName}
					/>
				</Route>

				<Route exact path={`${path}/single`}>
					<SingleSpec
						handleSetSpecName={handleSetSpecName}
					/>
				</Route>

				<Route exact path={`/suites/single`}>
					<SingleSpec
						handleSetSpecName={handleSetSpecName}
					/>
				</Route>
			</Switch>
		</div>
	);
}

export default Specs;
